/*
 * @Author: your name
 * @Date: 2021-06-23 14:32:54
 * @LastEditTime: 2021-07-13 18:08:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JN010665\src\utils\index.js
 */
export function trim(str) {
  return String.prototype.trim.call(str);
}

export function isType(arg, type) {
  return Object.prototype.toString.call(arg) === "[object " + type + "]";
}

// export function TMap2(latitude, longitude, addressText, detail) {
//   const TMap_URL =
//     "https://apis.map.qq.com/ws/place/v1/search?boundary=nearby(" +
//     latitude +
//     "," +
//     longitude +
//     "," +
//     1000 +
//     "," +
//     1 +
//     ")&keyword=" +
//     addressText +
//     detail +
//     "&get_subpois=0&key=6JZBZ-L5YH3-7IW3C-YH4WW-UP6RT-65FHK" +
//     "&callback=onMapCallback";
//   return new Promise(resolve => {
//     // 如果已加载直接返回
//     if (typeof TMap !== "undefined") {
//       resolve(TMap);
//       return true;
//     }
//     // 地图异步加载回调处理
//     window.onMapCallback = function() {
//       resolve(TMap);
//     };

//     // 插入script脚本
//     let scriptNode = document.createElement("script");
//     scriptNode.setAttribute("type", "text/javascript");
//     scriptNode.setAttribute("src", TMap_URL);
//     document.body.appendChild(scriptNode);
//   });
// }

export function isWeixin() {
  // return false;
  return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}
export function parseQuery() {
  const res = {};

  const query = (location.href.split("?")[1] || "")
    .trim()
    .replace(/^(\?|#|&)/, "");

  if (!query) {
    return res;
  }

  query.split("&").forEach(param => {
    const parts = param.replace(/\+/g, " ").split("=");
    const key = decodeURIComponent(parts.shift());
    const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}
const VUE_APP_API_URL = process.env.VUE_APP_API_URL || `${location.origin}/api`;

const VUE_APP_WS_URL =
  process.env.VUE_APP_WS_URL || `ws:${location.hostname}:20003`;

export { VUE_APP_API_URL, VUE_APP_WS_URL };
